import { MdOutlineDeleteOutline } from 'react-icons/md'

import { Button } from '~/components/Buttons'
import ThumbProduct from '~/components/ThumbProduct'
import i18n from '~/i18n'
import Image from '~/modules/retailMedia/components/BannersTable/TumbProduct'

const handleDeleteAsset = (data: DataAssetHandle) => {
  data.handleDeleteAsset(data)
}

export const schema: TableSchema<DataAssetHandle> = {
  media: {
    title: i18n.t('rm:campaign.create.Banner.table.media.title'),
    render: rowData => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Image url={rowData?.media_url}>
          <ThumbProduct url={rowData?.media_url} />
        </Image>
      </div>
    )
  },
  size: {
    title: i18n.t('rm:campaign.create.Banner.table.size.title'),
    render: rowData => (
      <div style={{ lineHeight: 1 }}>
        <strong className="title">
          <code>
            {rowData?.dimensions?.width} x {rowData?.dimensions?.height}
          </code>
        </strong>
      </div>
    ),
    className: 'order__details col__infos col__title'
  },
  actions: {
    render: rowData => (
      <div style={{ textAlign: 'right' }}>
        <Button
          onClick={() => handleDeleteAsset(rowData)}
          template="transparentCritical"
          size="xsmall"
          iconLeft={<MdOutlineDeleteOutline />}
          text={i18n.t(
            'rm:campaign.create.additionalAssets.table.actions.removeAsset'
          )}
        />
      </div>
    )
  }
}
